import { MetaPixelAnalytics } from '@chew/common/services/analytics/meta-pixel';

interface EventProperties {
  'Click to app': {};
  PageView: {};
}

export const metaPixelAnalytics = new MetaPixelAnalytics<EventProperties>();
